import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../../components/footer/Footer";
import CopyRight from "../../../components/footer/CopyRight";
import FancyFeatureTewentyTwo from "../../../components/features/FancyFeatureTewentyTwo";
import Smart from "../../../assets/images/assets/Smart Contract Development.png";
import Dapp from "../../../assets/images/assets/DApp Development.png";
import Chain from "../../../assets/images/assets/blockchain Integration.png";
import NFT from "../../../assets/images/assets/NFT Platforms & Marketplaces.png";
import Contract from "../../../assets/images/assets/Custom Tokenomics Design.png";

import FancyFeatureTen from "../../../components/features/FancyFeatureTen";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponentProduct from "../../../assets/Sub-component/CoreComponentProduct";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import { Link } from "react-router-dom";
import launchingimage from '../../../assets/Launchingimage.png'
import Cross_platform from '../../../assets/Services/Metaverse_royal/Advanced_tech/Cross-Platform_Play.svg'
import Customizable_Experience from '../../../assets/Services/Metaverse_royal/Advanced_tech/Customizable_Experience.svg'
import Game_Engine_Mastery from '../../../assets/Services/Metaverse_royal/Advanced_tech/Game_Engine_Mastery.svg'
import High_Def from '../../../assets/Services/Metaverse_royal/Advanced_tech/High-Definition_Visuals.svg'
import Reliable_Multiplayer_Performance from '../../../assets/Services/Metaverse_royal/Advanced_tech/Reliable_Multiplayer_Performance.svg'
import Streaming_Integration from '../../../assets/Services/Metaverse_royal/Advanced_tech/Streaming_Integration.svg'
import Unity_Engine_Optimization from '../../../assets/Services/Metaverse_royal/Advanced_tech/Unity_Engine_Optimization.svg'
import Unreal_Engine_5_Integration from '../../../assets/Services/Metaverse_royal/Advanced_tech/Unreal_Engine_5_Integration.svg'

import Community from '../../../assets/Services/Metaverse_royal/Royal_nft/Community-based_Decentralization_and_Governance.svg'
import Interoperability_and_Security from '../../../assets/Services/Metaverse_royal/Royal_nft/Interoperability_and_Security.svg'
import Limited from '../../../assets/Services/Metaverse_royal/Royal_nft/Limited-Edition_Collectibles.svg'
import Player from '../../../assets/Services/Metaverse_royal/Royal_nft/Player-Driven_Ecosystem.svg'
import Player_profiles_and_customization from '../../../assets/Services/Metaverse_royal/Royal_nft/Player_profiles_and_customization.svg'
import Unique_Virtual_Assets from '../../../assets/Services/Metaverse_royal/Royal_nft/Unique_Virtual_Assets.svg'

import Ancient_Ruins from '../../../assets/Services/Metaverse_royal/Themes_enviro/Ancient_Ruins.svg'
import Futuristic_Cityscape from '../../../assets/Services/Metaverse_royal/Themes_enviro/Futuristic_Cityscape.svg'
import Post from '../../../assets/Services/Metaverse_royal/Themes_enviro/Post-apocalyptic_Wasteland.svg'

const MetaverseRoyal = () => {
  const [technical, setTechnical] = useState(true);
  const [Reports, setReports] = useState(false);

  const handleclick = () => {
    setTechnical(true);
    setReports(false);
  };
  const handleclick2 = () => {
    setTechnical(false);
    setReports(true);
  };
  const FeaturesContent = [
    {
      bgColor: "#BCFFCB",
      icon: Futuristic_Cityscape,
      title: "Futuristic Cityscape",
      desc: `Explore a cyberpunk-inspired metropolis where you must survive your game amidst soaring skyscrapers, neon-lit streets, and expansive megacorporations.`,
      dataDealy: "0",
    },
    {
      bgColor: "#E0F8F8",
      icon: Ancient_Ruins,
      title: "Ancient Ruins",
      desc: `Walk through the mystical ruins, discover hidden temples and ancient civilizations, and battle your enemies in the ancient landscape.`,
      dataDealy: "100",
    },
    {
      bgColor: "#F7EDFF",
      icon:Post,
      title: "Post-apocalyptic Wasteland",
      desc: `Navigate the wrecked wasteland and make it through the destruction brought on by natural disasters and mutant animals trying to survive by scavenging for resources.`,
      dataDealy: "200",
    },
  ];

  const FeatureContent = [
    {
      icon: Unique_Virtual_Assets,
      title: "Unique Virtual Assets",
      subTitle: `We give you ownership of your virtual assets, such as properties owned by players and collectibles with limited editions. To ensure a completely secure performance, these assets are fully secured using cutting-edge blockchain technology.`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Player,
      title: "Player-Driven Ecosystem",
      subTitle: `Our platform guarantees players and creators the chance to make money off of their creations and supports in-game economies to provide a thriving marketplace for trading, purchasing, and selling digital assets. `,
      bgColor: "#6D49FF",
    },
    {
      icon: Interoperability_and_Security,
      title: "Interoperability and Security",
      subTitle: `Offering a solution for cross-game interoperability that lets users access resources from other virtual worlds. Our tools for decentralization and community-driven governance for upcoming games, with provenance verification services to guard against fraud.`,
      bgColor: "#FFB951",
    },
    {
      icon: Player_profiles_and_customization,
      title: "Player profiles and customization",
      subTitle: `Power up your player’s unique identity and achievements with customized avatars, titles, badges.`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Limited,
      title: "Limited-Edition Collectibles",
      subTitle: `We enable players to design and market exclusive limited edition collectibles, with assets fully secured on the blockchain to ensure authenticity and worth. This includes the in-game items that players can purchase, such as weapons and gaming skins`,
      bgColor: "#6D49FF",
    },
    {
      icon: Community,
      title: "Community-based Decentralization and Governance",
      subTitle: `Our decentralized approach ensures that the game reflects player preferences and fosters a vibrant, active community by empowering the participants to make significant decisions and suggestions through community-driven governance. `,
      bgColor: "#FFB951",
    },
  ];

  const feature = [
    {
      icon:Cross_platform ,
      title: "Cross-Platform Play",
      desc: "Play without any hassles on PCs, consoles, and mobile devices by interacting with other players and playing as a team without any restrictions. We provide your team members with a seamless and flexible experience, no matter where they are.",
    },
    {
      icon: High_Def,
      title: " High-Definition Visuals ",
      desc: " We offer powerful, eye-catching images with sophisticated rendering methods and high-resolution textures. Explore an immersive environment featuring vibrant visuals, realistic lighting, and entertaining gameplay. ",
    },
    {
      icon:Reliable_Multiplayer_Performance,
      title: "Reliable Multiplayer Performance  ",
      desc: " Our infrastructure offers low-latency networks and matchmaking to enable a smooth multiplayer experience. You can connect with clients, colleagues, and many others on multiple platforms without any restrictions or troubleshooting. ",
    },
    {
      icon: Customizable_Experience,
      title: "Customizable Experience  ",
      desc: "The platform puts you in control. Customize interface layouts, keybindings, and controls to meet your needs or preferences. It is possible to customize and optimize the experience by adjusting even fundamental mechanics like movement speed and equipment statistics.  ",
    },
  ];

  const feature2 = [
    {
      icon:Unity_Engine_Optimization ,
      title: "Unity Engine Optimization  ",
      desc: " The powerful efficacy of our Unity tools creates a meaningful gaming experience while optimizing your overall gaming performance. We allow multiple players to connect simultaneously on PC, console, and mobile platforms thanks to our multiplayer support.   ",
    },
    {
      icon:Unreal_Engine_5_Integration ,
      title: " Unreal Engine 5 Integration",
      desc: " Utilizing blockchain technology in conjunction with Unreal Engine to achieve smooth performance and strong visuals. It produces pertinent details for your game with the best effects, resulting in the ideal setting.  ",
    },
    {
      icon: Streaming_Integration,
      title: "Streaming Integration",
      desc: " Our infrastructure integrates into your game and enables players to broadcast their gameplay to a worldwide audience. Connect with people in the community and assemble a committed group of players for your game. ",
    },
    {
      icon: Game_Engine_Mastery,
      title: "Game Engine Mastery ",
      desc: " Gain expertise in game engine development by using tutorials, documentation, and other helpful tools. You can collaborate with other developers in specific forums and communities, sharing knowledge and guaranteeing support for your gaming efficiency.  ",
    },
  ];

  return (
    <>
     <img 
       src={launchingimage} 
        className="Bg-image z-0"
       alt="Launching"
     />
    <div className=" overflow-hidden ">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div className="bg-white">
        <div
          className=" container   d-flex align-items-center justify-content-center flex-column "
          style={{ minHeight: "100vh",position:'relative' }}
        >
          <h1 className="h1-heading fw-bold text-center">Metaverse Royale</h1>
          <p className="mt-3 h1-para lh-base">
            {" "}
            Get ready to conquer the world as you begin an immersive gaming
            battle and adapt to the new era of gaming.
          </p>

          <Link to="/request-quote">
            {" "}
            <button
              className="h3-para btn btn-primary mt-3 py-3 px-3 btn-gradient border-0  rounded-4"
              style={{ fontSize: 18 }}
            >
              {" "}
              Get Your Free Quote{" "}
            </button>{" "}
          </Link>
        </div>
      </div>

      <div className="fancy-feature-twentyTwo mt-80 mart ">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-8 m-auto">
              <div className=" text-center ">
                <h2 className="h2-heading mb-md-3 mb-2 pb-2 fw-bold">
                  Metaverse Royale NFT
                </h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <FancyFeatureTewentyTwo FeatureContent={FeatureContent} />
          </div>
        </div>
      </div>

      {/* =====================================================
            Feature Blog One
        ===================================================== */}
      <div className="fancy-feature-twentyTwo mt-80 mart ">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-8 m-auto">
              <div className=" text-center ">
                <h2 className="h2-heading mb-3 fw-bold">
                  Game Themes & Environment
                </h2>
              </div>
            </div>
          </div>
          <FancyFeatureTen FeaturesContent={FeaturesContent} />
        </div>
      </div>

      <div className="container mt-80 mart">
        <h2 className="h2-heading pb-3 text-center">
          Expertise in Game Engines and Advanced Technology{" "}
        </h2>
        <p className="h1-para text-center">
          We use our in-game and technical expertise to design scalable
          architecture that will provide the highest performance and
          dependability for your large player base.{" "}
        </p>
        <div>
          <div className="d-flex justify-content-evenly mt-3 pt-lg-2">
            <h3
              className={`h3-heading cursor ${
                technical ? "text-underline-gradient fw-semibold " : "fw-less"
              } `}
              onClick={handleclick}
            >
              Technical Specifications
            </h3>
            <h3
              className={`h3-heading cursor ${
                Reports ? "text-underline-gradient fw-semibold " : "fw-less"
              } `}
              onClick={handleclick2}
            >
              Game Engine Mastery
            </h3>
          </div>
          <CoreComponentProduct
            technical={technical}
            feature={feature}
            feature2={feature2}
          />
        </div>
      </div>

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default MetaverseRoyal;
